import * as React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  Container,
  Typography,
  Box,
  Grid,
  Stack,
  Button,
  Tooltip,
} from "@mui/material";
import { Page } from "../components/Page";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import TextField from "@mui/material/TextField";
import { getCheckOutReports, getCurrentUser } from "../api-config/config";
import DateRangeComponent from "../components/DateRangePicker";
import { CSVLink } from "react-csv";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { billView } from "../utils/miscellaneous";
import moment from "moment";

function CheckOutListGrid() {
  const navigate = useNavigate();
  const [checkinlist, setCheckinlist] = useState([] as any);
  const [dynamicRows, setDynamicRows] = useState([] as any);
  // Initialize range with today's date like CheckInList
  const [range, setRange] = useState(() => {
    const today = new Date();
    return {
      startDate: today,
      endDate: today,
      key: "selection",
    };
  });

  function onSetRange(value: any) {
    console.log(value);
    setRange(value);
  }

  const loggedUser = getCurrentUser();

  function searchWithDateRange() {
      const startDateString = moment(range.startDate).format("YYYY-MM-DD");
      const endDateString = moment(range.endDate).format("YYYY-MM-DD");
      
      // If it's a single date, same date for both from and to
      const fromDate = startDateString;
      const toDate = range.startDate.getTime() === range.endDate.getTime() ? startDateString : endDateString;
      
      fetchCheckinOrder(fromDate, toDate);
  }

  function fetchCheckinOrder(fromDateString: any, toDateString: any) {
      getCheckOutReports(
          fromDateString,
          toDateString,
          loggedUser?.hotel_code
      ).then((response: any) => {
          setCheckinlist(response.data);
          getRows(response.data);
      });
  }

  function getRows(data: any) {
      const allRows = [] as any;
      let id = 1;

      if (!data || !Array.isArray(data)) {
          setDynamicRows([]);
          return;
      }

      const startDate = new Date(range.startDate);
      const endDate = new Date(range.endDate);

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      // Sort data by check_out_time descending
      const sortedData = [...data].sort((a, b) => {
          const aTime = new Date(a.check_out_time).getTime();
          const bTime = new Date(b.check_out_time).getTime();
          return bTime - aTime;
      });

      sortedData.forEach((listData: any, key: any) => {
          // For checkout reports, we only want check_out status
          if (listData.booking_status === "check_out") {
              const checkOutTime = new Date(listData.check_out_time);
              checkOutTime.setHours(0, 0, 0, 0);
              
              const normalizedStartDate = new Date(startDate);
              normalizedStartDate.setHours(0, 0, 0, 0);
              
              const normalizedEndDate = new Date(endDate);
              normalizedEndDate.setHours(0, 0, 0, 0);

              // Check if checkout date falls within the selected range
              if (checkOutTime >= normalizedStartDate && checkOutTime <= normalizedEndDate) {
                  const date1 = new Date(listData.from_date);
                  const month1 = date1.toLocaleString("default", { month: "short" });
                  const date2 = new Date(listData.to_date);
                  const month2 = date2.toLocaleString("default", { month: "short" });
                  const diffDays = Math.round((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
                  
                  const obj = {
                      id: id++,
                      resId: listData.booking_id,
                      guestEmail: listData.email,
                      guestName: `${listData.guest_first_name} ${listData.last_name}`,
                      guestMobile: listData.mobile_number,
                      stayDuration: `${date1.getDate()} ${month1} - ${date2.getDate()} ${month2} (${diffDays == 1 ? 'night' : 'nights'})`,
                      roomType: listData.room_booking_info?.room_name || 'N/A',
                      pax: `${listData?.no_of_adults || 0}(A)${listData?.no_of_children || 0}(C)`,
                      status: listData.booking_status,
                      amount: listData.gross_amount,
                      guest_id: listData?.guest_id,
                      check_out_time: moment(listData.check_out_time).format('YYYY-MM-DD')
                  };
                  allRows.push(obj);
              }
          }
      });
      setDynamicRows([...allRows]);
  }


  // Updated useEffect to initialize with today's date like CheckInList
  useEffect(() => {
    const today = new Date();
    const startDateString = moment(today).format("YYYY-MM-DD");
    const endDateString = moment(today).format("YYYY-MM-DD");
    fetchCheckinOrder(startDateString, endDateString);
  }, []);
  const columns: GridColDef[] = [
    // {
    //   field: "id",
    //   headerName: "# Group ID",
    //   width: 90,
    //   headerClassName: "super-app-theme--header",
    //   hide: false,
    //   sortable: true,
    // },
    {
      field: "resId",
      flex: 1,
      headerName: "Booking ID",
      headerClassName: "super-app-theme--header",
      width: 110,
      editable: false,
      sortable: true,
    },
    {
      field: "roomType",
      flex: 1,
      headerName: "Room No",
      width: 140,
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: false,
    },
    {
      field: "guestName",
      flex: 1,
      headerName: "Guest Name",
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: false,
    },
    {
      field: "guestEmail",
      flex: 1.5,
      headerName: "Guest email",
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: false,
    },
    {
      field: "guestMobile",
      flex: 1,
      headerName: "Mobile",
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: false,
    },
    {
      field: "stayDuration",
      flex: 1,
      headerName: "Stay Duration",
      width: 200,
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: false,
    },
    {
      field: "check_out_time",
      flex: 1,
      headerName: "Check Out Date",
      width: 200,
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: false,
    },
   
    {
      field: "pax",
      flex: 1,
      headerName: "Pax",
      width: 90,
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: false,
    },
    // {
    //   field: "status",
    //   flex: 1,
    //   headerName: "Status",
    //   width: 110,
    //   editable: false,
    //   headerClassName: "super-app-theme--header",
    // },
    {
      field: "amount",
      flex: 1,
      headerName: "Amount",
      width: 110,
      editable: false,
      headerClassName: "super-app-theme--header",
      sortable: true,
    },
    {
      field: "Actions",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <span
            style={{ marginLeft: "20px", marginRight: "20px" }}
            onClick={(event) => {
              onPaymentFolioClick(cellValues.row)
            }}
          >
            <Button
              type="button"
              className="bg-sky-600 hover:bg-sky-400 text-stone-50 normal-case text-sm"
            >
              View Details
            </Button>
          </span>
        );
      },
      headerClassName: "super-app-theme--header",
    }
  ];

  // Add the payment folio click handler function
  function onPaymentFolioClick(row: any) {
    navigate("/main/foliodetails", {
      state: {
        booking_id: row?.resId,
      },
    });
  }

  return (
    <Box
      sx={{
        height: "100vh",
        width: "inherit",
        marginTop: 4,
        "& .super-app-theme--header": {
          backgroundColor: "#1976d2",
          color: "white",
        },
      }}
    >
      <p className="m-2.5">Select Date Range</p>
      <div className="flex justify-between p-2">
        <Stack direction="row" spacing={1} sx={{ justifyContent: "start" }}>
          <div className="border">
            <DateRangeComponent
              range={range}
              onSetRange={onSetRange}
              isShowPastDate={true}
            />
          </div>
          <Button
            type="button"
            onClick={() => searchWithDateRange()}
            className="bg-sky-600 hover:bg-sky-400 text-stone-50"
          >
            Search
          </Button>
        </Stack>
        <div className="flex justify-end mx-4">
          <CSVLink data={dynamicRows} filename={"checkout-list.csv"}>
            <Tooltip title="Download Excel">
              <Button
                type="button"
                className="bg-sky-600 hover:bg-sky-400 text-stone-50"
              >
                Download
              </Button>
            </Tooltip>
          </CSVLink>
        </div>
      </div>

      <DataGrid
        autoHeight
        rows={dynamicRows}
        columns={columns}
        rowsPerPageOptions={[10, 50, 100]}
        checkboxSelection
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
        initialState={{
          sorting: {
            sortModel: [{ field: "resId", sort: "desc" }],
          },
        }}
      />
    </Box>
  );
}

export default function CheckOutList() {
  return (
    <>
      <Page title="Home">
        <Container maxWidth="xl" sx={{ padding: "0 !important" }}>
          <Typography
            variant="h5"
            gutterBottom
            style={{
              color: "#0323f8",
              marginLeft: 10,
              fontWeight: 600,
              fontSize: 22,
            }}
          >
            Check Out Report
          </Typography>
          <CheckOutListGrid />
        </Container>
      </Page>
    </>
  );
}
